'use client'

import { useEffect, useRef } from 'react'
import type { StoreAnalyticsEventInput } from '@/lib/store-analytics'

export function trackStoreEvent(input: StoreAnalyticsEventInput) {
  if (typeof window === 'undefined') return

  const body = JSON.stringify({
    ...input,
    referrer: input.referrer ?? document.referrer,
  })

  if (navigator.sendBeacon) {
    const payload = new Blob([body], { type: 'application/json' })
    if (navigator.sendBeacon('/api/analytics', payload)) return
  }

  fetch('/api/analytics', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
  }).then(response => {
    if (!response.ok) {
      console.warn('[Analytics] Event was not recorded:', response.status)
    }
  }).catch(error => {
    console.warn('[Analytics] Event request failed:', error)
  })
}

export function StoreAnalyticsTracker(input: StoreAnalyticsEventInput) {
  const sentRef = useRef(false)

  useEffect(() => {
    if (sentRef.current) return
    sentRef.current = true
    trackStoreEvent(input)
  }, [input])

  return null
}
